import { observable } from 'mobx';
import logo from '../static/icon/logo.png';
import name from '../static/icon/name.png';

class HeaderMobx {
	@observable logoIcon = logo;
	@observable nameIcon = name;
	@observable phone = '0766 2233888';
	@observable bgm = './audio/bgm.mp3';
	@observable musicActive = true;
}

export default HeaderMobx;